import styled from 'styled-components';


/*
====================================
CONTENEDOR GENERAL
====================================
*/

export const TutorialesMain = styled.main`
    width: 100%;
    box-sizing: border-box;

    padding: 1.4rem 2.75rem 3rem 2.75rem;

    font-family: 'Montserrat', sans-serif;

    @media (max-width: 700px) {
        padding: 1.2rem 1rem 2rem 1rem;
    }
`;


export const TutorialesIntroduccion = styled.p`
    margin: 0.3rem 0 1.4rem 0;

    color: #646464;

    font-size: 0.85rem;
    font-weight: 400;
    line-height: 1.5;
`;

/*
====================================
HEADER FIJO TUTORIALES
====================================
*/

export const HeaderTutorialesFijo = styled.div`
    position: fixed;

    top: 0;
    left: 0;
    right: 0;

    width: 100%;

    z-index: 9999;

    background-color: #FFFFFF;
`;

export const EspacioHeaderTutoriales = styled.div`
    width: 100%;
    height: 78px;

    flex-shrink: 0;

    @media (max-width: 700px) {
        height: 70px;
    }
`;

/*
====================================
ENCABEZADO DE TUTORIALES
====================================
*/

export const EncabezadoTutoriales = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    gap: 0.75rem;

    margin-bottom: 0.2rem;
`;


export const TituloTutoriales = styled.h1`
    margin: 0;

    font-family: 'Montserrat', sans-serif;
    font-size: 18px;
    font-weight: 700;

    color: #2B2B2B;

    letter-spacing: 0.02em;
`;


export const BadgeTutorialesPreparacion = styled.span`
    display: inline-flex;
    align-items: center;

    padding: 0.3rem 0.7rem;

    background-color: #FBE6CE;

    color: #C57625;

    border-radius: 20px;

    font-family: 'Montserrat', sans-serif;
    font-size: 0.65rem;
    font-weight: 700;

    letter-spacing: 0.03em;
    text-transform: uppercase;
`;


/*
====================================
BUSCADOR
====================================
*/

export const BuscadorTutoriales = styled.div`
    display: flex;
    align-items: center;

    width: 100%;
    max-width: 480px;
    height: 46px;

    padding: 0 1rem;

    background-color: #FFFFFF;

    border: 1.5px solid #DDDDD8;
    border-radius: 12px;

    box-sizing: border-box;

    transition: border-color 0.2s ease;

    &:focus-within {
        border-color: #23AAAF;
    }
`;


export const IconoBuscador = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;

    margin-right: 0.7rem;

    color: #23AAAF;

    svg {
        width: 17px;
        height: 17px;
    }
`;


export const InputBuscador = styled.input`
    width: 100%;
    height: 100%;

    padding: 0;

    border: none;
    outline: none;

    background-color: transparent;

    font-family: 'Montserrat', sans-serif;
    font-size: 0.82rem;

    color: #2B2B2B;

    &::placeholder {
        color: #8A8A8A;
    }
`;


/*
====================================
SECCIONES
====================================
*/

export const SeccionTutoriales = styled.section`
    margin-top: 2rem;
`;


export const TituloSeccion = styled.p`
    margin: 0 0 0.9rem 0;

    color: #646464;

    font-size: 0.78rem;
    font-weight: 700;

    text-transform: uppercase;
    letter-spacing: 0.04em;
`;


/*
====================================
GRID DE VIDEOS
====================================
*/

export const GridTutoriales = styled.div`
    display: grid;

    grid-template-columns: repeat(4, minmax(0, 1fr));

    gap: 1rem;

    @media (max-width: 1100px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    @media (max-width: 850px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 550px) {
        grid-template-columns: 1fr;
    }
`;


/*
====================================
TARJETAS
====================================
*/

export const TarjetaTutorial = styled.div`
    overflow: hidden;

    background-color: #FFFFFF;

    border: 1px solid #EDEDE9;
    border-radius: 16px;

    cursor: pointer;

    transition:
        box-shadow 0.15s ease,
        transform 0.15s ease;

    &:hover {
        box-shadow: 0px 8px 22px rgba(0, 0, 0, 0.10);
        transform: translateY(-2px);
    }
`;


export const ImagenTutorial = styled.div`
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    height: 110px;

    background: ${({ $categoria }) => (
        $categoria === 'ejercicios'
            ? 'linear-gradient(135deg, #7A57D1, #A98CE0)'
            : 'linear-gradient(135deg, #0E7A7E, #23AAAF)'
    )};
`;


export const BotonPlay = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 42px;
    height: 42px;

    background-color: rgba(255, 255, 255, 0.92);

    border-radius: 50%;

    color: #2B2B2B;

    svg {
        width: 16px;
        height: 16px;

        margin-left: 2px;
    }
`;


export const BadgePopular = styled.span`
    position: absolute;

    top: 8px;
    left: 8px;

    padding: 3px 9px;

    background-color: #FFFFFF;

    color: #E7973C;

    border-radius: 10px;

    font-size: 0.65rem;
    font-weight: 700;
`;


export const DuracionTutorial = styled.span`
    position: absolute;

    right: 8px;
    bottom: 8px;

    padding: 2px 7px;

    background-color: rgba(0, 0, 0, 0.65);

    color: #FFFFFF;

    border-radius: 6px;

    font-size: 0.65rem;
    font-weight: 700;
`;


export const InformacionTutorial = styled.div`
    padding: 0.75rem 0.9rem 0.9rem 0.9rem;
`;


export const NombreTutorial = styled.div`
    margin-bottom: 0.25rem;

    color: #2B2B2B;

    font-size: 0.84rem;
    font-weight: 700;
    line-height: 1.35;
`;


export const DescripcionTutorial = styled.div`
    color: #646464;

    font-size: 0.75rem;
    line-height: 1.4;
`;


/*
====================================
TABS
====================================
*/

export const TabsTutoriales = styled.div`
    display: inline-flex;

    margin-top: 2.2rem;
    margin-bottom: 1.4rem;

    padding: 4px;

    background-color: #EFEFEA;

    border-radius: 24px;

    @media (max-width: 600px) {
        width: 100%;
        box-sizing: border-box;
    }
`;


export const TabTutorial = styled.button`
    padding: 9px 22px;

    border: none;
    border-radius: 20px;

    background-color: ${({ $activo }) => (
        $activo ? '#23AAAF' : 'transparent'
    )};

    color: ${({ $activo }) => (
        $activo ? '#FFFFFF' : '#646464'
    )};

    font-family: 'Montserrat', sans-serif;
    font-size: 0.82rem;
    font-weight: 600;

    cursor: pointer;

    transition:
        background-color 0.15s ease,
        color 0.15s ease;

    @media (max-width: 600px) {
        flex: 1;

        padding: 9px 10px;

        font-size: 0.72rem;
    }
`;


export const PanelTutoriales = styled.div`
    width: 100%;
`;


/*
====================================
SIN RESULTADOS
====================================
*/

export const MensajeSinResultados = styled.div`
    width: 100%;

    padding: 3rem 1rem;

    box-sizing: border-box;

    color: #646464;

    font-size: 0.85rem;
    text-align: center;
`;


/*
====================================
PREGUNTAS FRECUENTES
====================================
*/

export const SeccionFaq = styled.section`
    width: 100%;
    max-width: 820px;

    margin-top: 2.4rem;
`;


export const FaqItem = styled.div`
    border-bottom: 1px solid #EDEDE9;
`;


export const FaqPregunta = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;

    padding: 1rem 0.25rem;

    background-color: transparent;

    border: none;

    color: #2B2B2B;

    font-family: 'Montserrat', sans-serif;
    font-size: 0.84rem;
    font-weight: 600;
    text-align: left;

    cursor: pointer;

    svg {
        width: 16px;
        height: 16px;

        flex-shrink: 0;

        margin-left: 1rem;

        color: #646464;

        transform: ${({ $abierto }) => (
            $abierto ? 'rotate(180deg)' : 'rotate(0deg)'
        )};

        transition: transform 0.2s ease;
    }
`;


export const FaqRespuesta = styled.div`
    display: ${({ $abierto }) => (
        $abierto ? 'block' : 'none'
    )};

    padding: 0 2rem 1rem 0.25rem;

    color: #646464;

    font-size: 0.8rem;
    line-height: 1.6;
`;


/*
====================================
CURSO / FORMACIÓN
====================================
*/

export const CursoBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    gap: 1.5rem;

    width: 100%;
    max-width: 960px;

    margin-top: 2.2rem;

    padding: 1.6rem 1.9rem;

    box-sizing: border-box;

    background: linear-gradient(
        135deg,
        #F5FBFB,
        #EDE7FA
    );

    border: 1px solid #BFE0DF;
    border-radius: 20px;

    @media (max-width: 700px) {
        flex-direction: column;
        align-items: flex-start;

        padding: 1.3rem;
    }
`;


export const CursoTexto = styled.div`
    h3 {
        margin: 0 0 0.4rem 0;

        color: #2B2B2B;

        font-size: 1rem;
        font-weight: 700;
    }

    p {
        max-width: 520px;

        margin: 0;

        color: #646464;

        font-size: 0.8rem;
        line-height: 1.5;
    }
`;


export const BotonCurso = styled.button`
    flex-shrink: 0;

    padding: 0.75rem 1.5rem;

    background-color: #E7973C;

    border: none;
    border-radius: 22px;

    color: #FFFFFF;

    font-family: 'Montserrat', sans-serif;
    font-size: 0.82rem;
    font-weight: 700;

    cursor: pointer;

    &:hover {
        background-color: #D98831;
    }
`;


/*
====================================
MODAL DE VIDEO
====================================
*/

export const OverlayModalTutorial = styled.div`
    position: fixed;

    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    z-index: 5000;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 1rem;

    background-color: rgba(43, 43, 43, 0.55);

    box-sizing: border-box;
`;


export const ModalTutorial = styled.div`
    width: 640px;
    max-width: 92vw;
    max-height: 92vh;

    overflow: hidden;

    background-color: #FFFFFF;

    border-radius: 18px;

    box-shadow: 0px 20px 50px rgba(0, 0, 0, 0.30);
`;


export const ReproductorTutorial = styled.div`
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    aspect-ratio: 16 / 9;

    background-color: #1C1C1C;
`;


export const IframeTutorial = styled.iframe`
    width: 100%;
    height: 100%;

    border: none;
`;


export const ReproductorPlaceholder = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    gap: 0.7rem;

    color: #FFFFFF;

    text-align: center;

    span {
        padding: 0 1rem;

        color: rgba(255, 255, 255, 0.65);

        font-size: 0.75rem;
    }
`;


export const PlayGrande = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 60px;
    height: 60px;

    background-color: rgba(255, 255, 255, 0.15);

    border-radius: 50%;

    svg {
        width: 24px;
        height: 24px;

        margin-left: 3px;

        color: #FFFFFF;
    }
`;


export const ModalTutorialInfo = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    gap: 1rem;

    padding: 1.2rem 1.5rem;
`;


export const ModalTutorialTexto = styled.div`
    min-width: 0;
`;


export const ModalTutorialTitulo = styled.h3`
    margin: 0 0 0.4rem 0;

    color: #2B2B2B;

    font-size: 0.95rem;
    font-weight: 700;
`;


export const ModalTutorialDescripcion = styled.p`
    margin: 0;

    color: #646464;

    font-size: 0.8rem;
    line-height: 1.5;
`;


export const BotonCerrarTutorial = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;

    width: 32px;
    height: 32px;

    padding: 0;

    background-color: #EFEFEA;

    border: none;
    border-radius: 50%;

    color: #646464;

    cursor: pointer;

    svg {
        width: 14px;
        height: 14px;
    }

    &:hover {
        background-color: #E3E3DE;
    }
`;